/**
 * JoinCommunityTile — Home-screen entry to the Community Goals page.
 * Styled with the ember Passport CTA treatment so curated journeys stand out
 * directly beneath the Explore Map hero.
 */
import { Users, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { HelpTooltip } from "@/components/common/HelpTooltip";

export function JoinCommunityTile() {
  const navigate = useNavigate();
  return (
    <div className="relative">
      <div className="absolute right-2 top-2 z-10" onClick={(e) => e.stopPropagation()}>
        <HelpTooltip content="Community Goals are curated journeys around the UAE. Join one, visit the stops, collect stamps and unlock partner rewards along the way." />
      </div>
      <button
        type="button"
        onClick={() => navigate("/common-goals")}
        style={{ touchAction: "manipulation" }}
        className="group w-full flex items-center gap-3 rounded-2xl border border-ember/30 bg-ember/10 hover:bg-ember/15 transition-colors p-3 sm:p-4 text-left shadow-sm hover:shadow-md active:scale-[0.99]"
      >
        <div className="h-10 w-10 rounded-xl bg-ember flex items-center justify-center flex-shrink-0 shadow-md">
          <Users className="h-5 w-5 text-ember-foreground" />
        </div>
        <div className="flex-1 min-w-0 pr-6">
          <p className="text-sm font-semibold text-foreground">Explore curated journeys with special offers</p>
          <p className="text-xs text-muted-foreground truncate">
            Join a Community Goal, collect stamps, unlock rewards.
          </p>
        </div>
        <span className="shrink-0 hidden sm:inline-flex items-center gap-1.5 rounded-full bg-ember text-ember-foreground text-[11px] font-extrabold uppercase tracking-wide px-3.5 py-2 shadow-md group-hover:brightness-105 transition">
          Explore <ArrowRight className="h-3.5 w-3.5" />
        </span>
      </button>
    </div>
  );
}

export default JoinCommunityTile;

